import { useEffect, useState } from "react";
import { useAPIDirectCharge, useAPIPublic } from "../../tools/api";
import { useFormik } from "formik";
import * as yup from "yup";
import InputMask from "react-input-mask";
import { commaDigits, complexDigitToman, convertCurrencyToToman, convertPersian, isEmpty, isEmptyObject, validationMessage } from "../../tools/tools";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../address";

const ModalConfirm = ({ activePackage, msisdn }) => {
  const mdb = window["mdb"];
  const { queryTaxPercent } = useAPIPublic();
  const [tax, setTax] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const nav = useNavigate();
  const [calcTax, setCalcTax] = useState(0);
  const [isProcess, setIsProcess] = useState(false);
  const { isValidMSISDNToBuyPackage, redirectEPToIPGBankGateWay } = useAPIDirectCharge();
  const formik = useFormik({
    initialValues: {
      msisdn: msisdn,
    },
    validationSchema: yup.object({
      msisdn: yup
        .string()
        .required(validationMessage.required)
        .matches("^\\d{7}$", validationMessage.regex)
        .transform((value) => {
          return value.replace(/ /g, "");
        }),
    }),
    onSubmit: async (values) => {
      setIsProcess(true);
      if (!isEmpty(activePackage?.promotionId) && activePackage?.packagePrice === 0) {
        let req = {
          promotionid: activePackage.promotionId,
          msisdn: "0999" + values.msisdn.replace(/ /g, "").replace(/_/g, ""),
          bankid: 0,
          planid: process.env.REACT_APP_EP_PLANID,
          packagecode: activePackage.packageCode,
        };
        let response = await redirectEPToIPGBankGateWay(req);
        if (response) {
          let popConfirm = document.getElementById("modalConfirmPackage");
          new mdb.Modal.getInstance(popConfirm).hide();
          setTimeout(() => {
            nav(_adr.Root + _adr.Packages + _adr.PackageFactor + "?localInvoiceId=" + response.bankparameterone, {
              replace: true,
            });
          }, 2000);
        }
      } else {
        let req = {
          msisdn: "0999" + values.msisdn.replace(/ /g, "").replace(/_/g, ""),
          planid: process.env.REACT_APP_EP_PLANID,
          packageid: activePackage.packageId,
          promotionid: 0,
        };
        let responseValid = await isValidMSISDNToBuyPackage(req);
        if (responseValid) {
          let popConfirm = document.getElementById("modalConfirmPackage");
          new mdb.Modal.getInstance(popConfirm).hide();
          nav(_adr.Root + _adr.Packages + _adr.PackagePrefactor, {
            state: {
              packages: activePackage,
              msisdn: formik.values.msisdn,
              tax: tax,
            },
          });
        }
      }
      setIsProcess(false);
    },
  });
  useEffect(() => {
    formik.setFieldValue("msisdn", msisdn);
    const callAPI = async () => {
      await getTax();
    };
    if (!isEmptyObject(activePackage)) {
      callAPI();
    }
  }, [activePackage]);
  const getTax = async () => {
    let response = null;
    response = await queryTaxPercent();
    if (response) {
      setTax(parseInt(response));
    } else {
      setTax(9);
    }
    calcuPrice(parseInt(response));
  };
  const calcuPrice = async (taxValue = 0) => {
    let _price = (convertCurrencyToToman(activePackage.packagePrice) * taxValue) / 100;
    setCalcTax(_price);
    setTotalPrice(convertCurrencyToToman(activePackage.packagePrice) + _price);
  };
  return (
    <>
      <div className="modal fade" id="modalConfirmPackage" tabIndex="-1" aria-labelledby="modalConfirmPackage" aria-hidden="true">
        <div className="modal-dialog  modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body p-4">
              <div className="hold-package-confrim">
                <span className="hold-close">
                  <i className="icon-close-circle" data-dismiss="modal"></i>
                </span>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="holder-factor">
                      <div className="hold-title">
                        <h3>خرید بسته</h3>
                        <p>شماره موبایل آپتلی خود را وارد کنید</p>
                      </div>
                      <form onSubmit={formik.handleSubmit}>
                        <div className="mb-3">
                          <div className="hold-prefix">
                            <span className="prefix">0999</span>
                            <InputMask
                              autoComplete="off"
                              mask="999 99 99"
                              placeholder="-- -- --"
                              value={formik.values.msisdn}
                              onChange={(e) => {
                                e.target.value = convertPersian(e.target.value);
                                formik.handleChange(e);
                              }}
                              onBlur={formik.handleBlur}
                              type="text"
                              inputMode="numeric"
                              id="msisdn"
                              name="msisdn"
                              dir="ltr"
                              className="form-control"
                              readOnly={!isEmpty(activePackage?.promotionId)}
                            />
                          </div>
                          {formik.touched.msisdn && formik.errors.msisdn ? (
                            <span className="error invalid-feedback" style={{ display: "inline" }}>
                              {formik.errors.msisdn}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        {isEmpty(activePackage?.promotionId) && (
                          <>
                            <div className="holder-factor-item">
                              <ul className="list-unstyled">
                                <li>
                                  <div className="label">مبلغ بسته</div>
                                  <div className="value">
                                    <span>{complexDigitToman(activePackage.packagePrice)} </span>
                                    تومان
                                  </div>
                                </li>
                                <li>
                                  <div className="label">مالیات بر ارزش افزوده</div>
                                  <div className="value">
                                    <span dir="lrt">
                                      {commaDigits(calcTax)} ({tax ? tax : "0"}
                                      %)
                                    </span>
                                    <span> </span>
                                    تومان
                                  </div>
                                </li>
                                <li>
                                  <div className="label">مبلغ قابل پرداخت</div>
                                  <div className="value">
                                    <span> {commaDigits(totalPrice)} </span>
                                    تومان
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </>
                        )}

                        <div className="holder-button">
                          <button type="submit" disabled={isProcess} className={`btn ${isProcess && "disabled"}`}>
                            {isProcess ? <>درحال پردازش</> : !isEmpty(activePackage?.promotionId) ? <>فعالسازی</> : <>پرداخت</>}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="col-lg-6 mt-auto mb-auto">
                    <div className="packages ">
                      <div className="holder-packages">
                        <div>
                          <div>
                            <div className="item">
                              <div
                                className="head"
                                data-type={activePackage.packageType === 1 ? "internet" : activePackage.packageType === 2 ? "combo" : "roming"}
                              >
                                <h3>
                                  {activePackage.packageType === 1 ? "بسته اینترنت" : activePackage.packageType === 2 ? "بسته ترکیبی" : "بسته رومینگ"}
                                </h3>
                              </div>
                              <div className="body">
                                <div className="holder-title">
                                  <h3>{activePackage.packageName}</h3>
                                  <span>{activePackage.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
                                  <br />
                                  <span>کد رگولاتوری: {activePackage?.craCode}</span>
                                </div>
                                {activePackage.voiceCallInDoorDescription !== "0 دقیقه" &&
                                  activePackage.voiceCallOutDoorDescription !== "0 دقیقه" &&
                                  activePackage.smsDescription !== "0 عدد" && (
                                    <div className="holder-show-option">
                                      {activePackage.voiceCallInDoorDescription !== "0 دقیقه" && (
                                        <div className="item">
                                          <span className="label">{activePackage.voiceCallInDoorDescription}</span>
                                          <span className="value">
                                            {activePackage.packageType === 12 ? <>مکالمه با خطوط ترکیه</> : <>مکالمه آپتلی و غیرآپتلی</>}
                                          </span>
                                        </div>
                                      )}
                                      {/* {activePackage.voiceCallOutDoorDescription !==
                                        "0 دقیقه" && (
                                        <div className="item">
                                          <span className="label">
                                            {
                                              activePackage.voiceCallOutDoorDescription
                                            }
                                          </span>
                                          <span className="value">
                                            مکالمه برون شبکه
                                          </span>
                                        </div>
                                      )} */}
                                      {activePackage.smsDescription !== "0 عدد" && (
                                        <div className="item">
                                          <span className="label">{activePackage.smsDescription}</span>
                                          <span className="value">{activePackage.packageType === 12 ? <>پیامک به ایران</> : <>پیامک</>}</span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalConfirm;
